import Tools from '../../Tools.js';
import Scaling from '../../Scaling.js';
import BaseCharacter from '../base.js';

//TODO: implement character
var Noelle = (props) => {
  
  let scaleTable = {
    ascension0: {
      min: {level:1, maxHP:1012, baseAtk:16, defense:67, attr:0},
      max: {level:20, maxHP:2600, baseAtk:41, defense:172, attr:0}
    },
    ascension1: {
      min: {level:20, maxHP:3356, baseAtk:53, defense:222, attr:0},
      max: {level:40, maxHP:5027, baseAtk:80, defense:333, attr:0}
    },
    ascension2: {
      min: {level:40, maxHP:5564, baseAtk:88, defense:368, attr:0.075},
      max: {level:50, maxHP:6400, baseAtk:102, defense:423, attr:0.075}
    },
    ascension3: {
      min: {level:50, maxHP:7117, baseAtk:113, defense:471, attr:0.15},
      max: {level:60, maxHP:7953, baseAtk:126, defense:526, attr:0.15}
    },
    ascension4: {
      min: {level:60, maxHP:8490, baseAtk:135, defense:562, attr:0.15},
      max: {level:70, maxHP:9325, baseAtk:148, defense:617, attr:0.15}
    },
    ascension5: {
      min: {level:70, maxHP:9862, baseAtk:156, defense:652, attr:0.225},
      max: {level:80, maxHP:10698, baseAtk:170, defense:708, attr:0.225}
    },
    ascension6: {
      min: {level:80, maxHP:11235, baseAtk:178, defense:743, attr:0.30},
      max: {level:90, maxHP:12071, baseAtk:191, defense:799, attr:0.30}
    }
  };
  return BaseCharacter({
    ...props,
    name: 'Noelle',
    element: 'geo',
    equip: 'claymore',
    scaleTable: scaleTable,
    scaleAttr: 'defPct',
    attackTalent: {
      description: 'Favonius Bladework - Maid',
      level: props.attack,
      type: "NormalAtk",
      defaultImpl: {
        talentProperties: {
          comboTable: [
            {dmg:0.711, anim:0.5}, 
            {dmg:0.709, anim:0.6}, 
            {dmg:0.883, anim:1}, 
            {dmg:0.865, anim:0.75}, 
            {dmg:1.12, anim:1}
          ]
        },
        duration: 1,
        Resolve(result) {
          result = Scaling.ScaleAttackCombo(result);
          result.attributes.element='physical';
          return result;
        }
      },
      chargedImpl: {
        type: "ChargeAtk",
        duration: 1,
        Resolve(result) {
          result = Scaling.ScaleTalent(1.02, result);
          result.attributes.element='physical';
          return result;
        }
      },
      spinningImpl: {
        type: "ChargeAtkHold",
        duration: 1,
        Resolve(result) {
          //account for windup animation
          result.setDuration(1);
          let spinAnimation = [0.3, 0.4, 0.4, 0.5, 0.35, 0.5, 0.4, 0.4, 0.5, 0.9];
          [...Array(9)].forEach((e,i) => {
            result.talentEffects.push(Tools.CreateSideEffect(result, {
              description: 'Beidou Spin Attack',
              entity: 'Beidou',
              duration: spinAnimation[i],
              effectExtension: true,
              type: 'ChargeAtkHold',
              Resolve(result) {
                result = Scaling.ScaleTalent(0.562, result);
                result.attributes.element='physical';
                return result;
              }
            }));
          });
          result.talentEffects.push(Tools.CreateSideEffect(result, {
            ...result.initiator.chargedAttack,
            effectExtension: true
          }))
          return result;
        }
      }
    },
    skillTalent: {
      description:'Breastplate',
      level: props.skill,
      type: 'Skill',
      defaultImpl: {
        Prepare(result) {
          return result;
        },
        Resolve(result) {
          return result;
        }
      }
    },
    burstTalent: {
      description: 'Sweeping Time',
      level: props.burst,
      type: 'Burst',
      defaultImpl: {
        Prepare(result) {
          return result;
        },
        Resolve(result) {
          return result;
        }
      }
    },
    passiveAsc1: {
      description: 'Devotion',
      PersistentResolve(result, context) {
        return result;
      }
    },
    passiveAsc4: {
      description: 'Nice and Clean',
      PersistentResolve(result, context) {
        return result;
      }
    },
    passiveOther: [{
      description: 'Maid\'s Knighthood',
      PersistentResolve(result, context) {
        return result;
      }
    }],
    constellations: [
      ...BaseCharacter.Constellation53,
    ]
  });
};

export default Noelle;